import { Model, AccessorsMutatorsDecorator } from "../../helpers";
import { Property } from "./property.model";

/**
 * @class Translation
 */
export class EventAdditionalOption extends Model {
    
    static get TYPE_BLOCK_DATES() {
        
        return 1;
    }
    
    static get TYPE_COURTESY_HOLD() {
        
        return 2;
    }
    
    static get TYPE_OUT_OF_SERVICE() {
        
        return 3;
    }

    static get validationModel() {
        
        return {
            length_hold: {
                label: 'LENGTH_OF_HOLD_HOURS',
                messages: {
                    notLessThan: 'LENGTH_OF_HOLD_MUST_BE_GREATER_THAN_O'
                }
            }
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'property_id', 'from', 'to', 'type', 'together', 'reason', 'length_hold', 'guest_id',
    'name', 'last_name', 'classification', 'email', 'phone', 'phone_code', 'rooms', 'created_at')(EventAdditionalOption);



// WEBPACK FOOTER //
// ./src/pms-api/models/event-additional-option.model.js